import { render, staticRenderFns } from "./chapter.vue?vue&type=template&id=656711bc&scoped=true"
import script from "./chapter.vue?vue&type=script&lang=js"
export * from "./chapter.vue?vue&type=script&lang=js"
import style0 from "./chapter.vue?vue&type=style&index=0&id=656711bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656711bc",
  null
  
)

export default component.exports